// extracted by mini-css-extract-plugin
module.exports = {"message":"_3Nr7iw","messageRedesign":"_2YYtnV"};